import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import { HeroSection } from './sections/HeroSection.tsx';
import { FeaturesSection } from './sections/FeaturesSection.tsx';
import { UseCasesSection } from './sections/UseCasesSection.tsx';
import { HowItWorksSection } from './sections/HowItWorksSection.tsx';
import { TestimonialsSection } from './sections/TestimonialsSection.tsx';
import { PricingSection } from './sections/PricingSection.tsx';
import { FAQSection } from './sections/FAQSection.tsx';
import { ClosingSection } from './sections/ClosingSection.tsx';

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: #ffffff;
  color: #333333;
`;

const B2BLanding: React.FC = () => {
  return (
    <PageContainer>
      <Helmet>
        <title>Spin To Connect for Business - Revolutionize Customer Engagement</title>
        <meta name="description" content="Discover how Spin To Connect can help businesses engage customers, generate leads, and boost sales with interactive wheel experiences." />
        <meta property="og:title" content="Spin To Connect for Business" />
        <meta property="og:description" content="Revolutionize Customer Engagement" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="YOUR_BUSINESS_LANDING_PAGE_URL" />
        {/* Add more Open Graph tags as needed */}
      </Helmet>
      <HeroSection />
      <FeaturesSection />
      <UseCasesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <PricingSection />
      <FAQSection />
      <ClosingSection />
    </PageContainer>
  );
};

export default B2BLanding; 